export default __webpack_public_path__ + "static/media/emptycart.de00bd81.svg";